import api from './api';

// Get all blog posts (including drafts)
export const getAllBlogPosts = async (page = 1, limit = 10, filters = {}) => {
  try {
    // axios encodes params safely (searches containing &, #, + etc.)
    const params = { page, limit };
    if (filters.status) params.status = filters.status;
    if (filters.category) params.category = filters.category;
    if (filters.search) params.search = filters.search;
    if (filters.tag) params.tag = filters.tag;

    const response = await api.get('/blogs', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching blog posts:', error);
    throw error;
  }
};

// Get a single blog post by ID
export const getBlogPostById = async (id) => {
  try {
    const response = await api.get(`/blogs/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching blog post with ID ${id}:`, error);
    throw error;
  }
};

// Create a new blog post
export const createBlogPost = async (postData) => {
  try {
    const response = await api.post('/blogs', postData);
    return response.data;
  } catch (error) {
    console.error('Error creating blog post:', error);
    throw error;
  }
};

// Update an existing blog post
export const updateBlogPost = async (id, postData) => {
  try {
    const response = await api.patch(`/blogs/${id}`, postData);
    return response.data;
  } catch (error) {
    console.error(`Error updating blog post with ID ${id}:`, error);
    throw error;
  }
};

// Delete a blog post
export const deleteBlogPost = async (id) => {
  try {
    const response = await api.delete(`/blogs/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting blog post with ID ${id}:`, error);
    throw error;
  }
};

// Toggle publish status of a blog post
export const togglePublishStatus = async (id) => {
  try {
    const response = await api.patch(`/blogs/${id}/toggle-publish`);
    return response.data;
  } catch (error) {
    console.error(`Error toggling publish status for blog post with ID ${id}:`, error);
    throw error;
  }
};

// Toggle featured status of a blog post
export const toggleFeaturedStatus = async (id) => {
  try {
    const response = await api.patch(`/blogs/${id}/toggle-featured`);
    return response.data;
  } catch (error) {
    console.error(`Error toggling featured status for blog post with ID ${id}:`, error);
    throw error;
  }
};

// Get all categories
export const getCategories = async () => {
  try {
    const response = await api.get('/blogs/categories');
    return response.data;
  } catch (error) {
    console.error('Error fetching blog categories:', error);
    throw error;
  }
};

// Get all tags
export const getTags = async () => {
  try {
    const response = await api.get('/blogs/tags');
    return response.data;
  } catch (error) {
    console.error('Error fetching blog tags:', error);
    throw error;
  }
};